// The route table of core.md §7.0 — ONE place that turns a screen name into a
// path, and one place that lists the <Route> patterns App.jsx mounts.
//
// Screens navigate by NAME (`navigate('patient', { caseId })`), never by URL
// literal, so a path can be renamed here and nowhere else. tests/routing.test.js
// pins the three-way agreement between this map, the <Route>s in App.jsx and
// the nav list in ./nav.js.
//
// Ten routes, ten built screens. A route for scheduling, a clinic, a case
// library or a grading dashboard would be a route to nothing — core.md §18 says
// building any of them is a defect, and a route is the first thing that appears
// for a screen nobody has built.

/** The record tabs, in the order the strip shows them. `overview` is omitted from the URL. */
export const RECORD_TABS = ['overview', 'history', 'visits', 'timeline'];
export const DEFAULT_RECORD_TAB = 'overview';
export const isRecordTab = (id) => RECORD_TABS.includes(id);
export const resolveRecordTab = (id) => (isRecordTab(id) ? id : DEFAULT_RECORD_TAB);

/** Path builders, keyed by screen name. */
export const ROUTES = {
  // «بیماران» — the landing route: a student opens this app to their own
  // practice patients, because there is nothing else it could open to.
  patients: () => '/patients',

  // `tab` is a URL SEGMENT: a refresh, a back button and a pasted link all have
  // to restore the part of the record the student was reading. `overview` is
  // the default and is left out of the URL.
  patient: (d = {}) =>
    `/patients/${d.caseId}${d.tab && d.tab !== DEFAULT_RECORD_TAB ? `/${d.tab}` : ''}`,

  // The visit workspace — a full-height surface with its own back button.
  visit: (d = {}) => `/patients/${d.caseId}/visit/${d.encounterId}`,

  // The patient-level chat page. No `threadId` = a fresh, unsaved conversation.
  chat: (d = {}) => `/patients/${d.caseId}/chat${d.threadId ? `/${d.threadId}` : ''}`,

  // «گفتگو» in the nav: resumes the most recent thread, or asks which patient.
  chatLanding: () => '/chat',

  credits: () => '/credits',
  profile: () => '/profile',
};

/**
 * The <Route> patterns, in the order App.jsx declares them. The patient record's
 * `:tab?` would otherwise swallow `/patients/:caseId/visit/...`, so the two
 * fixed-segment routes are listed FIRST and the optional-segment one last.
 */
export const ROUTE_PATTERNS = {
  patients: '/patients',
  visit: '/patients/:caseId/visit/:encounterId',
  chat: '/patients/:caseId/chat/:threadId?',
  patient: '/patients/:caseId/:tab?',
  chatLanding: '/chat',
  credits: '/credits',
  profile: '/profile',
};

/** Is this pathname inside a visit workspace or a chat page? */
export const isVisitPath = (pathname) => /^\/patients\/[^/]+\/visit(\/|$)/.test(pathname || '');
export const isChatPath = (pathname) => /^\/patients\/[^/]+\/chat(\/|$)/.test(pathname || '');

export default ROUTES;
